import axios from "axios";

export const GET_ALL_TICKET_CONSULTATION = "GET_ALL_TICKET_CONSULTATION";
export const ADD_TICKET_CONSULTATION = "ADD_TICKET_CONSULTATION";
export const GET_ONE_TICKET_CONSULTATION = "GET_ONE_TICKET_CONSULTATION";
export const DELETE_TICKET_CONSULTATION = "DELETE_TICKET_CONSULTATION";

export const getAllTicketConsultation = () => (dispatch) => {
  try {
    return axios.get("/ticket-consultations").then((cli) => {
      // console.log(cli);
      dispatch({ type: GET_ALL_TICKET_CONSULTATION, payload: cli.data });
    });
  } catch (error) {
    console.log("ERREUR GET ALL TICKET CONSULTATION ", error);
  }
};

export const addTicketConsultation =
  (ticketConsultationState, history) => (dispatch) => {
    
    try {
      return axios
        .post("/ticket-consultations", {data : ticketConsultationState})
        .then((cli) => {
          dispatch({ type: ADD_TICKET_CONSULTATION, payload: cli.data });
        });
    } catch (error) {
      console.log("ERREUR AJOUT CONSULTATION TICKET ", error);
    }
  };

export const getOneTicketConsultation = (id) => (dispatch) => {
  try {
    return axios.get(`/ticket-consultations/${id}`).then((rep) => {
      dispatch({ type: GET_ONE_TICKET_CONSULTATION, payload: rep.data });
    });
  } catch (error) {
    console.log("ERREUR ", error);
  }
};

export const getTicketConsultationsByUser = (userID) => (dispatch) => {
  try {
    const querya = `query getTicketsConsultations($userID:IDFilterInput!){
      ticketConsultations (filters : {users_permissions_user : {documentId: $userID}}) {
        documentId
        createdAt
        publishedAt
        ticket{
          documentId,
          createdAt,
          objet
        }
        updatedAt
        users_permissions_user{
          documentId,
          username,
          email
        }
      }
    }`;
    const variablesa = { userID: { eq : userID.toString() }};

    const body = {
      query: querya,
      variables: variablesa,
    };
    //console.log(body)

    return axios.post("/graphql", body).then((rep) => {
      //console.log(rep);
      const consultations = rep.data.data.ticketConsultations?.map(
        (consultation) => {
          return {
            ...consultation,
            id: consultation?.documentId,
            ticket: {
              ...consultation?.ticket,
              id: consultation?.ticket?.documentId,
            },
            users_permissions_user: {
              ...consultation?.users_permissions_user?.documentId,
              id: consultation?.users_permissions_user?.documentId,
            },
          };
        }
      );

      dispatch({
        type: GET_ALL_TICKET_CONSULTATION,
        payload: consultations,
      });
    });
  } catch (error) {
    console.log("ERREUR GET ALL BUILDING ", error);
  }
};

export const deleteTicketConsultation = (id, callback) => (dispatch) => {
  //console.log(id, `${axios.defaults.baseURL}/ticket-consultations/${id}`)
  try {
    return axios.delete(`/ticket-consultations/${id}`).then((cli) => {
      dispatch({ type: DELETE_TICKET_CONSULTATION, payload: cli.data });
      if (callback && typeof(callback)==="function") callback();
    });
  } catch (error) {
    console.log("ERREUR DELETE TICKET ", error);
  }
};

export const getTicketConsultationsByUserByTicketSync = (ticketID, userID) => {
  try {
    const querya = `query getTicketsConsultations($userID:IDFilterInput!,$ticketID:IDFilterInput!){
      ticketConsultations (
        filters : {
          and: [
            {users_permissions_user : { documentId: $userID } },
            {ticket : { documentId: $ticketID } }
          ]
        }
      ) {
        documentId
        createdAt
        publishedAt
        ticket{
          documentId,
          createdAt,
          objet
        }
        updatedAt
        users_permissions_user{
          documentId,
          username,
          email
        }
      }
    }`;
    const variablesa = {
      userID: {eq : userID?.toString()},
      ticketID: {eq : ticketID?.toString()},
    };
    //console.log(userID);
    const body = {
      query: querya,
      variables: variablesa,
    };
    //console.log(body)
    return axios.post("/graphql", body);
  } catch (error) {
    console.log("ERREUR GET ALL BUILDING ", error);
  }
};
